import { datadogLogs } from '@datadog/browser-logs';

/*
  This utility file creates a wrapper around datadog logging.
  This exposes the common logging function in a general manner.
  This will make it easier to change loggers if we ever choose to do so in the future.
  We wrap in a try/catch and swallow any error it might throw to not break the app.
 */

export const initializeLogger = () => {
  if (window.LOG_CLIENT_TOKEN && window.LOG_SITE) {
    try {
      datadogLogs.init({
        clientToken: window.LOG_CLIENT_TOKEN,
        site: window.LOG_SITE,
        forwardErrorsToLogs: true,
        env: window.ENV,
      });
    } catch (error) {
      console.log(error);
    }
  }
};

export const logError = (errorMessage, additionalInformation) => {
  if (window.LOG_CLIENT_TOKEN && window.LOG_SITE) {
    try {
      datadogLogs.logger.error(errorMessage, additionalInformation);
    } catch (error) {
      console.log(error);
    }
  }
};

// [handoff] Buffer every logInfo message into sessionStorage so logs emitted BEFORE the
// Safari Web Inspector can be attached (e.g. on the first page / across the initial
// redirect + reload) are still readable afterward. sessionStorage survives same-origin
// navigations, so after attaching you can read the full history at any point with:
//   JSON.parse(sessionStorage.getItem('sl-handoff-log'))
// (or just view the sl-handoff-log key in the Storage tab). Tokens/PII are never logged.
const HANDOFF_LOG_KEY = 'sl-handoff-log';
const bufferLog = (message, additionalInformation) => {
  try {
    const buffer = JSON.parse(sessionStorage.getItem(HANDOFF_LOG_KEY) || '[]');
    buffer.push({
      t: new Date().toISOString(),
      message,
      data: additionalInformation,
    });
    // keep the last 200 entries so a long flow can't bloat storage
    sessionStorage.setItem(HANDOFF_LOG_KEY, JSON.stringify(buffer.slice(-200)));
  } catch (error) {
    // ignore storage/serialization errors — buffering is best-effort
  }
};

export const logInfo = (message, additionalInformation) => {
  // Always emit to the browser console so these are visible in Safari Web Inspector
  // (incl. the in-app browser / SFSafariViewController), regardless of whether the
  // DataDog browser SDK is configured for this env.
  console.log(message, additionalInformation);
  bufferLog(message, additionalInformation);
  if (window.LOG_CLIENT_TOKEN && window.LOG_SITE) {
    try {
      datadogLogs.logger.info(message, additionalInformation);
    } catch (error) {
      console.log(error);
    }
  }
};
